<template>
  <div v-if="parentEntity" class="mt-3">
    <right-panel class="float-right" id="sidebar-new-datasubject" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form @onSave="onDatasubjectSaved" />
      </div>
    </right-panel>
    <!-- TKP-236 n.10: ilgili kişi düzenleme (organizasyon sözlüğü formu, düzenleme kipinde kütüphane sekmesi yok) -->
    <right-panel class="float-right" id="sidebar-edit-datasubject" width="600px" icon="" @hidden="editPanelClosed">
      <div class="pl-5 pr-5" data-test="datasubject-edit-panel">
        <DatasubjectForm v-if="editingDatasubject" :hide-library="true" />
      </div>
    </right-panel>
    <!-- TKP-203: yeni eklenen ilgili kişiye süreçteki başka bir ilgili kişinin özelliklerini kopyalama önerisi -->
    <copy-features-dialog v-if="breadCrumbs.department && (breadCrumbs.process || parentEntity.process)" ref="copyDialog" :department="breadCrumbs.department" :process="copyProcess" :target-row-ids="copyTargets" @copied="paginate" />

    <right-panel class="float-right" id="sidebar-info-datasubject" width="800px">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("datasubject.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <h5>{{ $t("datasubject.used-places") }}</h5>
          <table v-if="info && info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("department.text") }}</th>
                <th>{{ $t("process.text") }}</th>
                <th>{{ $t("datasource.text") }}</th>
                <th>{{ $t("data.text") }}</th>
                <th class="text-center">{{ $t("common.edit") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.department.name | translate }}
                </td>
                <td>
                  {{ i.process.name | translate }}
                </td>
                <td>
                  {{ sourceNames(i) }}
                </td>
                <td>{{ i.name | translate }}</td>
                <td style="text-align: center;">
                  <a href="javascript:;void(0);" @click="deleteByIdFromHierarchy(i)" v-b-tooltip.hover :title="$t('common.delete')">
                    <i class="bx bx-trash-alt text-danger"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <!-- Begin: Pagination -->

        <div v-if="info" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
    </right-panel>

    <!-- Begin : Inventory — TKP-76 / TKP-188: dört seviyede AYNI panel, kapsam bu ilgili kişi satırı -->
    <template>
      <right-panel class="float-right" id="sidebar-datasubject-inventory" width="1400px" icon="" @hidden="inventoryPanelClosed">
        <HierarchyInventoryView
          v-if="selectedBox && parentEntity && breadCrumbs.department"
          ref="inventoryPanel"
          :department="breadCrumbs.department"
          :process="breadCrumbs.process || parentEntity.process"
          :node="parentEntity"
          :datasubject="selectedBox"
          data-test="datasubject-inventory-view"
          @onNodeSaved="paginate"
        />
      </right-panel>
    </template>
    <!-- End : Inventory -->

    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          <span
            v-html="
              $t('process-data.datasubject-owned-list', {
                department: $options.filters.translate(breadCrumbs.department && breadCrumbs.department.name),
                process: $options.filters.translate(breadCrumbs.process && breadCrumbs.process.name),
                data: dataName,
              })
            "
          >
          </span>
        </span>

      </div>
      <div>
        <div class="search2  mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="text">{{ item.name | translate }}<draft-badge entity-type="NODE_DATASUBJECT" :entity-id="item._id" /></div>
          <div class="actions d-flex justify-content-center">
            <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
              <i class="iconoir-trash"></i>
            </div>

            <div
              class="action"
              @click="fetchInfo(item.datasubject)"
              v-on:click.stop
              v-b-toggle="'sidebar-info-datasubject'"
              v-b-tooltip.hover
              :title="$t('datasubject.used-places')"
            >
              <i class="iconoir-info-circle"></i>
            </div>

            <!-- TKP-236 n.10: eski sistemdeki düzenleme (ilgili kişinin adı ve kategorisi — organizasyon sözlüğü kaydı) -->
            <div class="action" data-test="datasubject-edit" @click="editDatasubject(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>

            <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
          </div>
        </div>

        <!-- TKP-186 md.16: bu veriye taslağımda eklediğim ilgili kişiler — gölge satır; envanter paneli açılır, özellikleri taslağa yazılır -->
        <div v-for="row in shadowRows" :key="'shadow-' + row._id" class="ds-card--item" style="opacity: .85; border-style: dashed;" :class="selectedBoxStyle(row)" data-test="shadow-datasubject" @click="selectBox(row)">
          <div class="text">
            {{ row.name | translate }}
            <b-badge variant="info" class="ml-1"><i class="bx bx-edit"></i> {{ $t(row.__draft.packageStatus === "SUBMITTED" ? "approval.badge.submitted" : "approval.badge.draft") }} · {{ $t("approval.new-record") }}</b-badge>
          </div>
          <div class="actions d-flex justify-content-center">
            <div class="action" @click="showInventoryPanel(row)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
          </div>
        </div>

        <div class="ds-card--item2" @click="openRightPanel">
          <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
    </div>
  </div>
</template>

<script>
import DraftBadge from "@/modules/approval/draft-badge"; // TKP-104
import { shadowDatasubjectRowsOf } from "@/modules/approval/draft-overlay"; // TKP-186 md.16
import Form from "@modules/process-data/organization-process-data-datasubject-form";
import DatasubjectForm from "@modules/datasubject/organization-datasubject-form"; // TKP-236 n.10
import HierarchyInventoryView from "@modules/inventory/component/hierarchy/hierarchy-inventory-view"; // TKP-188
import CopyFeaturesDialog from "@modules/inventory/component/hierarchy/copy-features-dialog"; // TKP-203
import { sourceNamesOf } from "@/modules/process-data/info-row";

/**
 * TKP-27 / Faz 6 dilim 6.1 — ilgili kişi kutusu düğüm bazlı (`/process-data/datasubject/*`). Satır tipi eski
 * `OrganizationDataDatasubject`; işleme/aktarım/hak panelleri satır id'si ile çalışmaya devam eder. Kaynak seçimi gerekmez.
 */
export default {
  components: { DraftBadge, Form, DatasubjectForm, HierarchyInventoryView, CopyFeaturesDialog },
  data() {
    return {
      copyTargets: [], // TKP-203
      editingDatasubject: false, // TKP-236 n.10
      request: {
        options: { page: 1, limit: 13, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      libraryScopedState: "datasubject",

      infoRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    /** TKP-186 md.16: taslağımdaki ilgili kişi satırları (bu düğüm). */
    shadowRows() {
      return this.parentEntity ? shadowDatasubjectRowsOf(this.$store.getters["approval/drafts"], this.parentEntity._id, this.currentAccount && this.currentAccount._id) : [];
    },
    parentEntity() {
      return this.$store.getters["entityBoxes/data"];
    },
    /**
     * Düğümün kendi `name` alanı YOK: `OrganizationProcessData` bir `OrganizationRelationEntity`, ad veri kaydında
     * durur (`node.data.name`) — `inventory.vue` ve düğüm envanter paneli de böyle okuyor. Başlık `breadCrumbs.data.name`
     * okuduğu için hep boş kalıyordu: "... > Verisi ile ilişkili İlgili Kişiler".
     */
    dataName() {
      const node = this.$store.getters["entityBoxes/data"];
      return this.$options.filters.translate(node && node.data && node.data.name);
    },
    breadCrumbs() {
      return {
        ...this.$store.getters["entityBoxes/data"],
        department: this.$store.getters["entityBoxes/department"],
        process: this.$store.getters["entityBoxes/process"],
        data: this.$store.getters["entityBoxes/data"],
      };
    },
    pagination() {
      return this.$store.getters["organizationProcessDataDatasubject/pagination"];
    },
    /** TKP-203: kopyalama penceresinin süreci (kaynak satırlar bu süreçten). */
    copyProcess() {
      const p = this.breadCrumbs.process || (this.parentEntity && this.parentEntity.process);
      return p && p._id ? p : p ? { _id: p } : null;
    },
    isLoading() {
      return this.$store.getters["organizationProcessDataDatasubject/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },

    infoItem() {
      return this.$store.getters["organizationDatasubject/infoItem"];
    },
    info() {
      return this.$store.getters["organizationDatasubject/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationDatasubject/isInfoLoading"];
    },

    //inventory
    productInventoryStore() {
      return this.currentProduct == "GDPR" ? "gdprInventory" : "kvkkInventory";
    },
    selectedBox() {
      return this.$store.getters["entityBoxes/datasubject"];
    },
  },
  watch: {
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    parentEntity(item) {
      this.debounce(() => this.paginate());
    },

    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clearFrom", "datasubject");
      this.$store.commit("organizationProcessDataDatasubject/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedDataSubject = this.$store.getters["entityBoxes/datasubject"];
        if (selectedDataSubject) {
          await this.selectBox(selectedDataSubject);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    selectedBoxStyle(item) {
      if (this.selectedBox?._id == item._id) {
        return "bg-main text-white";
      }
    },

    async paginate() {
      if (!this.parentEntity) {
        return;
      }
      const request = { ...this.request };
      request.query = {
        ...request.query,
        processData: { value: { _id: this.parentEntity._id }, isObject: true },
      };

      await this.$store.dispatch("organizationProcessDataDatasubject/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationProcessDataDatasubject/delete", item._id);
        if (this.selectedBox?._id == item._id) this.$store.commit("entityBoxes/clearFrom", "datasubject");
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    interceptForSetParent(payload) {
      payload.processData = this.parentEntity;
    },

    sourceNames(row) {
      return sourceNamesOf(row, this.$options.filters.translate);
    },
    async deleteByIdFromHierarchy(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        // TKP-27: satır düğümdür — bu kişinin düğümdeki satırları (göçten kalma çift satırlar dahil)
        for (const id of item.rel_ids || [item.rel_id]) {
          await this.$store.dispatch("organizationProcessDataDatasubject/delete", id);
        }
        this.$toast.success(this.$t("common.delete-successful"));
        this.fetchInfo();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.delete-failed") });
      }
    },

    /** TKP-203: ilgili kişi eklendi → süreçte başka ilgili kişi satırı ya da başka veri varsa kopyalama önerisi. */
    async onDatasubjectSaved(event) {
      await this.paginate();
      const ids = ((event && event.savedIds) || []).map(String);
      const otherRows = (this.pagination?.docs ?? []).some((d) => !ids.includes(String(d._id)));
      const otherNodes = (this.$store.getters["organizationProcessData/pagination"]?.docs ?? []).length > 1;
      if (!ids.length || !(otherRows || otherNodes)) return;
      if (!(await this.confirm(this.$t("inventory.copy.offer-row", { count: ids.length })))) return;
      this.copyTargets = ids;
      await this.$nextTick();
      this.$refs.copyDialog && this.$refs.copyDialog.open();
    },
    /** TKP-236 n.10: satırın ilgili kişisi (organizasyon sözlüğü kaydı) tam haliyle yüklenip düzenleme formunda açılır. */
    async editDatasubject(item) {
      const id = item && item.datasubject && (item.datasubject._id || item.datasubject);
      if (!id) return;
      try {
        // kimlikle getirme ucu yok — arama ucuyla (organizasyon kapsamlı)
        const { data } = await this.$store.dispatch("organizationDatasubject/paginateForSearch", { options: { page: 1, limit: 1 }, query: { _id: { value: String(id), isObject: true } } });
        const doc = data && data.docs && data.docs[0];
        if (!doc) return;
        this.$store.commit("organizationDatasubject/editedEntity", doc);
        this.editingDatasubject = true;
        this.$root.$emit("bv::toggle::collapse", "sidebar-edit-datasubject");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    editPanelClosed() {
      this.editingDatasubject = false;
      this.$store.commit("organizationDatasubject/editedEntity");
      this.paginate();
    },
    rightPanelClosed() {
      this.paginate();
    },
    selectBox(item) {
      this.$store.dispatch("entityBoxes/selectDatasubject", item);
    },

    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationDatasubject/fetchInfo", { item, pagination: this.infoRequest });
    },

    openRightPanel() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject");
    },

    //inventory

    // TKP-76: veri kartıyla aynı panel açılır (ilgili kişi satırına odaklı); yükleme ve toplu güncelleme kapsamı panelde
    showInventoryPanel(item) {
      this.$store.commit("entityBoxes/datasubject", item);
      this.$store.commit("organizationProcessDataDatasubject/selectedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-datasubject-inventory");
    },
    inventoryPanelClosed() {
      this.$refs.inventoryPanel?.releaseBulkScope();
      this.paginate();
    },

  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>

<style scoped>
.when-opened,
.when-closed {
  font-size: 20px;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
